<template>
  <v-container fluid class="public-articles pa-4 pa-md-5">
    <v-layout wrap>
      <v-flex xs12 md3 class="pr-md-4 mb-4">
        <v-card flat class="article-list">
          <v-card-title class="headline px-0">Public website</v-card-title>
          <v-list class="pa-0" two-line>
            <v-list-tile
              v-for="article in articles"
              :key="article.id"
              :class="{ 'grey lighten-3': selected && selected.id === article.id }"
              @click="selectArticle(article)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ article.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ languageName(article.locale) }} · /{{ article.slug }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon small>edit</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 md9>
        <v-card flat v-if="selected" class="article-editor">
          <v-card-title class="px-0">
            <div>
              <div class="headline">About · {{ languageName(selected.locale) }}</div>
              <div class="caption grey--text">The public page updates when this article is saved.</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="black" dark :loading="saving" :disabled="saving || !changed" @click="save">Save</v-btn>
          </v-card-title>

          <v-text-field v-model="draft.title" label="Page title" @input="changed = true"></v-text-field>
          <label class="editor-label">Body</label>
          <text-editor :value="draft.body" @input="updateBody"></text-editor>
        </v-card>

        <v-progress-linear v-else-if="loading" indeterminate color="black"></v-progress-linear>
        <v-alert v-else :value="true" type="info" outline>No public articles found. Run the API database seeds.</v-alert>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" right top :color="snackbarColor" :timeout="4000">
      {{ snackbarText }}
      <v-btn flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import TextEditor from '@/components/artworks/TextEditor'
import axios from '@/utils/apiClient'

export default {
  name: 'PublicArticles',
  components: { TextEditor },
  data () {
    return {
      articles: [],
      selected: null,
      draft: { title: '', body: '' },
      loading: true,
      saving: false,
      changed: false,
      snackbar: false,
      snackbarColor: 'black',
      snackbarText: ''
    }
  },
  created () {
    this.loadArticles()
  },
  methods: {
    loadArticles () {
      axios.get(`${this.$globals.apiserver}/public_articles.json`)
        .then((response) => {
          this.articles = response.data
          if (this.articles.length) this.selectArticle(this.articles[0])
        })
        .catch(() => this.notify('Could not load public articles.', 'red'))
        .then(() => { this.loading = false })
    },
    selectArticle (article) {
      this.selected = article
      this.draft = { title: article.title, body: article.body }
      this.changed = false
    },
    updateBody (body) {
      this.draft.body = body
      this.changed = true
    },
    save () {
      this.saving = true
      axios.patch(`${this.$globals.apiserver}/public_articles/${this.selected.id}.json`, {
        public_article: this.draft
      }).then((response) => {
        const index = this.articles.findIndex((article) => article.id === response.data.id)
        this.$set(this.articles, index, response.data)
        this.selected = response.data
        this.draft = { title: response.data.title, body: response.data.body }
        this.changed = false
        this.notify('Public article saved.', 'black')
      }).catch((error) => {
        const errors = error.response && error.response.data && error.response.data.errors
        this.notify(errors ? errors.join(', ') : 'Could not save public article.', 'red')
      }).then(() => { this.saving = false })
    },
    languageName (locale) {
      return locale === 'es' ? 'Español' : 'English'
    },
    notify (text, color) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.public-articles { max-width: 1400px; }
.article-list, .article-editor { border-top: 1px solid #000; }
.editor-label { display: block; margin: 12px 0 8px; color: rgba(0, 0, 0, .54); font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/public/PublicArticles.vue